import "./FoodCard.css";

import FoodImage from "./FoodImage/FoodImage";
import FoodInfo from "./FoodInfo/FoodInfo";
import FoodActions from "./FoodActions/FoodActions";

function FoodCard(props) {
  const {
    food,
    onView,
    onEdit,
    onDelete,
    onToggleAvailability,
  } = props;

  return (
    <div className="food-card">

      <FoodImage food={food} />

      <FoodInfo food={food} />

      <FoodActions
        food={food}
        onView={onView}
        onEdit={onEdit}
        onDelete={onDelete}
        onToggleAvailability={onToggleAvailability}
      />

    </div>
  );
}

export default FoodCard;